import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import colors from "vuetify/lib/util/colors";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "fa",
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: colors.indigo.darken1,
        secondary: colors.deepOrange.base,
        accent: colors.lightBlue.base,
        info: colors.blue.base,
        error: colors.red.darken2,
        success: colors.green.base,
        warning: colors.red.darken4,
        bodyText: colors.grey.darken3,
      },
    },
  },
});
